import { render, staticRenderFns } from "./addRemarks.vue?vue&type=template&id=84280f6a&scoped=true&"
import script from "./addRemarks.vue?vue&type=script&lang=js&"
export * from "./addRemarks.vue?vue&type=script&lang=js&"
import style0 from "./addRemarks.vue?vue&type=style&index=0&id=84280f6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84280f6a",
  null
  
)

export default component.exports